import $ from "jquery";
import Flickity from "flickity";

export default {
  init() {
    // JavaScript to be fired on all pages
    // console.log('common');
  },
  finalize() {
    // console.log('common finalize');

    /**
     * Flickity slider
     */
    if ($(".main-carousel").length > 0) {
      $(document).ready(function () {
        // Only initialize Flickity if the element doesn't have embla classes
        $(".main-carousel").each(function () {
          const $carousel = $(this);
          if (
            !$carousel.hasClass("js-carousel") &&
            !$carousel.closest(".embla").length
          ) {
            new Flickity($carousel[0], {
              contain: true,
              // initialIndex: 0,
              pageDots: false,
              wrapAround: false,
              cellAlign: "left",
              accessibility: false,
              prevNextButtons: true,
            });
            $(".latest-news__box").attr("aria-hidden", "false");
          }
        });
      });
    }

    /**
     * lazysizes js. Lazyload bg images. Convert data-bg to its css bg when in view.
     */
    document.addEventListener("lazybeforeunveil", function (e) {
      var bg = e.target.getAttribute("data-bg");
      if (bg) {
        e.target.style.backgroundImage = "url(" + bg + ")";
      }
    });

    /**
     * Header navigation (mega menu + mobile drawer) lives in javascripts/menu.js
     */

    /**
     * Add class to header on scroll
     */
    function checkScroll() {
      if ($(window).scrollTop() >= 150) {
        $("header").addClass("header--scrolled");
      } else {
        $("header").removeClass("header--scrolled");
      }
    }

    $(document).ready(function () {
      checkScroll();
      $(window).scroll(checkScroll);
    });

    /**
     * Search toggle classes in header
     */
    function openHeaderSearch() {
      $(".header__search-form-wrapper").addClass("active");
      $(".header__search").attr("aria-expanded", "true");
      $(".header__search-input").focus();
      $(".site-overlay").fadeIn().addClass("active");
    }

    function closeHeaderSearch() {
      $(".header__search-form-wrapper").removeClass("active");
      $(".header__search").attr("aria-expanded", "false").focus();
      $(".site-overlay").fadeOut().removeClass("active");
    }

    $(".header__search").click(openHeaderSearch);
    $(".header__search-form-close").click(closeHeaderSearch);

    $(document).on("keydown", function (e) {
      if (
        e.key === "Escape" &&
        $(".header__search-form-wrapper").hasClass("active")
      ) {
        closeHeaderSearch();
      }
    });

    /**
     * Video block - start video on click img
     */
    $(".video-image").click(function (ev) {
      $(this).addClass("hidden");
      $(this).parent().addClass("playing");
      $(this).prev().children("iframe")[0].src += "&autoplay=1";
      $(this).prev().children("iframe").addClass("playing");
      ev.preventDefault();
    });

    /**
     * Sidebar menu functions (delegated for reliable binding)
     */
    $(document).on("click", ".sidebar-menu__trigger", function () {
      var $btn = $(this);
      var $panel = $btn.closest(".sidebar-menu__first-level").children(".sidebar-menu__sub_menu");
      var willOpen = !$btn.hasClass("sidebar-menu__trigger--active");

      $btn.toggleClass("sidebar-menu__trigger--active");
      $btn.attr("aria-expanded", willOpen ? "true" : "false");
      $panel.toggleClass("sidebar-menu__first-level--active");
      if (willOpen) {
        $panel.removeAttr("hidden");
      } else {
        $panel.attr("hidden", "hidden");
      }
    });

    $(document).on("click", ".sidebar-menu__mobile-trigger", function () {
      $(".sidebar-text").toggleClass("sidebar-text--active");
      $(this).toggleClass("sidebar-menu__mobile-trigger--active");
      $(this).next(".sidebar-menu").toggleClass("visible");
    });

    /**
     * Staff popup function
     */
    $(".js-coworker-img").click(function (e) {
      var $this = $(this);
      $(".coworker-item__img--popup-wrap").removeClass("active");
      $($this).next(".coworker-item__img--popup-wrap").addClass("active");
    });

    $(".js-coworker-item__img--close-popup").click(function (e) {
      $(".coworker-item__img--popup-wrap").removeClass("active");
    });

    /**
     * Add class to target blank link inside page content
     */
    $(
      '.main-content a[target="_blank"], .accordition__answer a[target="_blank"]'
    ).addClass("external-link");

    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
